import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "category" }
const _hoisted_2 = { class: "gifts-category__content" }

import { computed, watch, onMounted } from 'vue';

import useContext from '@/composables/useContext';
import { setCategoryMeta } from '@/composables/useMeta';
import useGiftCard from '@/composables/useGiftCard';
import useGiftProductListing from '@/composables/useGiftProductListing';

import GiftCategoryMedia from '@/components/plp/CategoryMedia.vue';
import GiftProductListing from '@/components/plp/GiftListing.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'GiftCategory',
  setup(__props) {

const { page, cart, navigate, channel } = useContext();
const { activeGiftCard } = useGiftCard();
const { singleSection } = useGiftProductListing();

const blocks = computed(() => {
  return page.value?.blocks?.Main || [];
});

const giftCard = computed(() => {
  const giftCards = activeGiftCard.value?.giftCards || [];
  return giftCards.length > 0 ? giftCards[0] : null;
});

const isSingleSection = computed(() => singleSection?.value);

const isTestAssortment = computed(() => {
  return page.value?.dataJson?.dataJson?.category?.fields?.TestAssortment;
});

onMounted(() => {
  setCategoryMeta();
  watch(
    () => cart.value,
    async () => {
      if (
        !isTestAssortment.value &&
        !giftCard.value &&
        cart.value?.currency?.id
      ) {
        await navigate(channel.value.rootPath);
      }
    },
    {
      immediate: true
    }
  );
});

return (_ctx: any,_cache: any) => {
  const _component_blocks_repeater = _resolveComponent("blocks-repeater")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(GiftCategoryMedia),
      _createVNode(_component_blocks_repeater, {
        blocks: blocks.value,
        class: "gifts-category__blocks"
      }, null, 8, ["blocks"]),
      _createVNode(GiftProductListing, {
        displayLinks: 
          isSingleSection.value !== undefined && isSingleSection.value === false
        
      }, null, 8, ["displayLinks"])
    ])
  ]))
}
}

})